import { render, staticRenderFns } from "./StrategyModal.vue?vue&type=template&id=089e2677"
import script from "./StrategyModal.vue?vue&type=script&lang=ts"
export * from "./StrategyModal.vue?vue&type=script&lang=ts"
import style0 from "./StrategyModal.vue?vue&type=style&index=0&id=089e2677&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports